export default "__VITE_ASSET__51a6a00a__"